import { cx } from '@linaria/atomic';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { CaretLeftIconSmall } from '../../../icon/icons-small/caret-left-small';
import { CaretRightIconSmall } from '../../../icon/icons-small/caret-right-small';
import { NakedButton } from '../../../naked/naked-button.component';
import {
  scrollArrowBaseStyle,
  scrollArrowDirectionStyles,
  scrollArrowDisabledStyle,
  scrollArrowEnabledStyle,
} from '../common-styles';

type ScrollButtonProps = CommonHTMLButtonAttributes & {
  direction: 'left' | 'right';
  show: boolean;
  disabled: boolean;
};

export const ScrollButton = ({ direction, disabled, show, ...rest }: ScrollButtonProps) => {
  if (!show) return null;

  const IconComponent = direction === 'left' ? CaretLeftIconSmall : CaretRightIconSmall;

  return (
    <span
      className={cx(
        scrollArrowBaseStyle,
        scrollArrowDirectionStyles[direction],
        !disabled && scrollArrowEnabledStyle,
        disabled && scrollArrowDisabledStyle
      )}
    >
      <NakedButton disabled={disabled} {...rest}>
        <IconComponent />
      </NakedButton>
    </span>
  );
};
